<template>
  <nav>
      <div class='brand-wrapper'>
         <span class="burger" @click="$emit('toggle-sidebar')" content="Toggle ToC" v-tippy>
            <img src="../../../../assets/icons/burger.svg">
         </span>
         <span class="brand" @click="getHome">MEP Tool</span>
         <!-- <span v-if="regionSelect" class="tool-label"> [ {{ getCurrentTool }} ] </span> -->
      </div>
      <region-select-form v-if="regionSelect"/>
      <div class='nav-links'>
         <el-menu
            class="settings-menu"
            mode="horizontal"
            collapse-transition
            unique-opened
            >
            <download-menu/> 
            <el-submenu index="1">
               <template slot="title"><i class='el-icon-user'/></template>
               <el-menu-item index="name" @click="() => {}">
                  {{user.first_name}} - {{user.role}}
              </el-menu-item>
               <hr>
               <router-link :to="{name: 'landing-page'}">
                  <el-menu-item index="landing-page" >
                     Home
                  </el-menu-item>
               </router-link>
               <router-link :to="$route.fullPath.includes('admin') ? {name: 'home'} : {name: 'admin'}">
                  <el-menu-item index="admin" v-if="isManagerOrHigher" @click="() => {}">
                     {{$route.fullPath.includes('admin') ? 'MEP Tool' : 'Admin'}}
                  </el-menu-item>
               </router-link>
               <hr>
               <el-menu-item index="logout" @click="logOut"><i class="el-icon-switch-button"></i>Logout</el-menu-item>
            </el-submenu>
         </el-menu>
      </div>
   </nav>
</template>

<script>
import RegionSelectForm from '../RegionSelectForm';
import DownloadMenu from '../../../molecules/Home/DownloadMenu';
import { Menu, Submenu, MenuItem } from 'element-ui';

import { mapGetters,mapActions } from 'vuex';

export default {
   components: {
      RegionSelectForm,
      DownloadMenu,
      'el-menu': Menu,
      'el-submenu': Submenu,
      'el-menu-item': MenuItem,
   },
   props: {
      regionSelect: {
         type: Boolean,
         default: true,
      }
   },
   computed: {
      ...mapGetters('tools', ['getCurrentTool']),
      ...mapGetters('users', ['user', 'isManagerOrHigher']),
   },
   methods: {
      ...mapActions('users', ['logOut']),
      isCurrentTool(tool)
      {
         return this.getCurrentTool === tool;
      },
      getHome()
      {
         this.$router.push({name: 'home'});
      }
   }
}
</script>

<style lang="scss">
.settings-menu.el-menu {
   border-bottom: none;
   .el-submenu__icon-arrow {
      display: none;
   }
}
.nav-links > ul > li > div,
.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
   background-color: transparent;
}

.el-dropdown-link {
   cursor: pointer;
   color: #409EFF;
}
.el-icon-arrow-down {
   font-size: 12px;
}
.nav-links > ul > li > div > i {
   /* .nav-links > ul.el-menu--horizontal.el-menu > li.el-menu-item.tools { */
   color: white !important;
   
   &:hover,
   &:focus {
      background: rgba(white,0.3);
   }
   &.selected-tool {
      font-weight: 600;
      background: none;
   }
}

nav {
   background: $primary-color;
   padding: 0 1em;
   display: flex;
   justify-content: space-between;
   * {
      color: $light-color;
      font-family: $primary-font;
   }
   .brand-wrapper {
      display: flex;
      align-items: center;
      .burger {
         display: flex;
         align-items: center;
         justify-content: center;
         border-radius: 50%;
         height: 38px;
         width: 38px;
         cursor: pointer;
         margin-right: 4px;
         img {
            height: 28px;
            width: 28px;
         }
         &:hover {
            background: #fff3;
         }
      }
      .brand {
         display: inline-block;
         color: $light-color;
         font-size: 20px;
         font-weight: 600;
         padding: 14px 0px;
         cursor: pointer;
      }
      .tool-label {
         display: inline-block;
         color: darken($light-color, 20%) !important;
         font-weight: 400;
         transform: translate(2px, -2px);
         font-size: 14px;
         width: 6ch;
      }
   }
   .nav-links {
      display: flex;
      align-items: center;
      * {
         font-size: 16px;
         cursor: pointer;
         position: relative;
         font-family: $primary-font;
      }
   }
   .settings-menu {
      background: transparent;
      &:hover {
         background: transparent;
      }
   }
}

@media screen and (max-width: 880px) {
   nav {
      flex-direction: column;
      align-items: center;
      .brand {
         padding: 4px 0;
      }
      div {
         margin-bottom: 5px;
      }
   }
}
</style>
